import React from 'react';
import { GameCard } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import './GameCard.scss';

type GameCardProps = {
  handleModalClick: (value: any) => void;
  gameData: any;
  rtl: boolean;
}

function GameCardComponent({ handleModalClick, gameData: { latency: games }, rtl }: GameCardProps) {
  const { t } = useTranslation();
  const truncate = (str: string, n: number) => {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  }

  return (
    <div className={rtl ? 'gameCard__container gameArabic' : 'gameCard__container gameEnglish'}>
      {games.length > 0 && games.map((game: any, i: number) => {
        return (
          <React.Fragment key={game.gameTitle}>
            <GameCard rtl={rtl} gameSubTitle={t('ping_this_game')} buttonText={t('ping_game')} onPingClick={() => handleModalClick(game)} gameTitle={truncate(game.gameTitle, 12)} gameImage={require(`../../assets/img/${game.gameTitle}.png`)} />
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default GameCardComponent;